import {useEffect, useState} from "react";
import {create, destroy, get, update} from "custom/demo/requests/admin/validation-automated-reports";
import {list as listStudies} from "custom/demo/requests/admin/validation-studies";
import Field from "components/helpers/form/field";
import useForm from "custom/demo/helpers/admin/use-form";
import useAppContext from "lib/hooks/use-app-context";

const frequencyOptions = [
  {name: "3 Hours", value: "3 Hours"},
  {name: "Daily", value: "Daily"},
  {name: "3 Days", value: "3 Days"},
  {name: "Weekly", value: "Weekly"},
  {name: "Monthly", value: "Monthly"},
  {name: "3 Months", value: "3 Months"},
  {name: "6 Months", value: "6 Months"}
];

const defaults = {
  active: true,
  email: "",
  frequency: "3 Hours",
  name: "",
  retest: false,
  validation_study_id: ""
};

export default function Form() {
  const {user} = useAppContext();
  const {id, onChange, onDestroy, onSubmit, record} = useForm({
    actions: {create, destroy, get, update},
    defaults: {...defaults, email: user?.profile?.email || ""},
    path: "/admin/validation/automated_reports"
  });
  const [studyOptions, setStudyOptions] = useState([]);

  useEffect(() => {
    listStudies().then((data) => {
      setStudyOptions(data.records.map((s) => ({name: s.name, value: String(s.id)})));
    });
  }, []);

  return (
    <div className="container">
      <h1>Validation Automated Report</h1>
      <form onSubmit={onSubmit}>
        {id && (
          <Field
            checked={record.active}
            label="Active"
            name="active"
            onChange={onChange}
            type="checkbox"
          />
        )}
        <Field
          label="Email"
          name="email"
          onChange={onChange}
          placeholder="Email"
          required={true}
          type="email"
          value={record.email}
        />
        <Field
          label="Frequency"
          name="frequency"
          onChange={onChange}
          options={frequencyOptions}
          type="select"
          value={record.frequency}
        />
        <Field
          label="Name"
          name="name"
          onChange={onChange}
          placeholder="Name"
          required={true}
          value={record.name}
        />
        <Field
          checked={record.retest}
          disabled={Boolean(id)}
          label="Retest"
          name="retest"
          onChange={onChange}
          type="checkbox"
        />
        <Field
          disabled={Boolean(id)}
          label="Study"
          name="validation_study_id"
          onChange={onChange}
          options={studyOptions}
          placeholder="Select Study"
          type="select"
          value={String(record.validation_study_id || "")}
        />
        <div className="flex gap-2 mt-4">
          <button className="btn btn-blue" type="submit">Save</button>
          {id && <button className="btn btn-red" onClick={onDestroy} type="button">Delete</button>}
        </div>
      </form>
    </div>
  );
}
